import DataModuleBaseUtils from './data-module-base-utils';

export default class StudentUsageUtils extends DataModuleBaseUtils {
  whole = ({rawValue, totalStudents}) => {
    if (totalStudents < 5) {
      return 5;
    }

    return rawValue ? 100 : 200;
  };

  value = ({rawValue, totalStudents}) => {
    if (!rawValue || totalStudents < 5) {
      return isNaN(parseInt(totalStudents)) ? 0 : totalStudents;
    }

    const value = rawValue ? Math.round(rawValue) : 0;

    return value > 100 ? 100 : value;
  };

  decoratedValue = ({rawValue, value, totalStudents}) => {
    if (!rawValue || totalStudents < 5) {
      return value.toLocaleString();
    }

    return `${value.toLocaleString()}%`;
  };

  comparisonValue = ({rawValue, districtAverage, totalStudents}) => {
    const defaultValue = '25';

    if (totalStudents < 5) {
      return '5';
    }

    if (!rawValue) {
      return defaultValue;
    }

    if (!districtAverage) {
      return defaultValue + '%';
    }

    return `${Math.round(districtAverage)}%`;
  };

  headerCopy = () => 'Students Using Raise Me';

  headerLinkCopy = ({totalStudents}) => `Invite ${totalStudents > 0 ? 'More' : ''} Students`;

  bodyHeader = ({rawValue, value, totalStudents}) => {
    if (totalStudents < 5) {
      return this.emptyStateBodyHeader();
    } else if (rawValue) {
      return `${value}% of students at your school use Raise Me`;
    }

    return `${value} students at your school use Raise Me`;
  };

  bodyContent = ({totalStudents}) => {
    if (totalStudents < 5) {
      return this.emptyStateBodyContent();
    }

    return 'Bringing on at least 50% of students helps you build a college-going culture.';
  };

  surveyLocalStorageKey = () => 'Survey::DataModules:StudentUsage';
}
